<template>
  <section class="featured-in">
      <div class="featured-in__content container">
          <h1 class="featured-in__title">Recently Featured In</h1>
          <ul class="featured-in__list">
            <li><img src="../assets/featured-in/logo-rolling-stone.png" alt="Logo Rolling Stone"></li>
            <li><img src="../assets/featured-in/logo-forbes.png" alt="Logo Forbes"></li>
            <li><img src="../assets/featured-in/logo-denver-business-journal.png" alt="Logo Denver Business Journal"></li>
            <li><img src="../assets/featured-in/logo-leafly.png" alt="Logo Leafly"></li>
          </ul>
      </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturedIn',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/FeaturedIn.scss";
</style>
